/**
 * Tooltip Component
 * A simple CSS-based tooltip that appears on hover
 */

import React, { ReactNode } from 'react';

interface TooltipProps {
  children: ReactNode;
  label: string;
  position?: 'top' | 'bottom';
}

export function Tooltip({ children, label, position = 'bottom' }: TooltipProps): React.ReactElement {
  return (
    <div className="relative group">
      {children}
      <div
        className={`
          absolute left-1/2 -translate-x-1/2 z-50
          px-2 py-1 rounded-lg
          bg-charcoal-800 text-white text-xs font-medium
          whitespace-nowrap
          opacity-0 invisible group-hover:opacity-100 group-hover:visible
          transition-all duration-200 delay-300
          pointer-events-none
          ${position === 'top' ? 'bottom-full mb-2' : 'top-full mt-2'}
        `}
      >
        {label}
        {/* Arrow */}
        <div
          className={`
            absolute left-1/2 -translate-x-1/2
            w-0 h-0 border-4 border-transparent
            ${position === 'top'
              ? 'top-full border-t-charcoal-800'
              : 'bottom-full border-b-charcoal-800'
            }
          `}
        />
      </div>
    </div>
  );
}
